<div data-testid="projects-trend" class="projects-trend">
  <header class="projects-trend__header">
    <div class="projects-trend__titles">
      <h4 class="projects-trend__title">{{ cardTitle }}</h4>
      <p class="projects-trend__description">{{ description }}</p>
      <p *ngIf="numbersText" data-testid="projects-trend-numbers" class="projects-trend__numbers">{{ numbersText }}</p>
    </div>
  </header>
  <app-admin-dashboard-empty *ngIf="failed" data-testid="projects-trend-failed" icon="fa-regular fa-circle-exclamation"
                             [title]="failedTitle" body="Try again, or change the filters." [compact]="true"></app-admin-dashboard-empty>
  <app-admin-dashboard-empty *ngIf="loaded && !failed && isEmpty" data-testid="projects-trend-empty" icon="fa-regular fa-folder-open"
                             [title]="emptyTitle"></app-admin-dashboard-empty>
  <div *ngIf="loaded && !failed && !isEmpty" #chart data-testid="projects-trend-chart" class="projects-trend__chart"></div>
  <div *ngIf="!loaded" class="projects-trend__chart"></div>
  <ng-container *ngIf="loaded && !failed && !isEmpty">
    <p *ngFor="let note of notes" data-testid="projects-trend-note" class="projects-trend__note">{{ note }}</p>
  </ng-container>
</div>
